import React, { useEffect, useState } from 'react';
import {
    Button,
    ButtonGroup,
    Dropdown
} from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { addExpense, addNewIncome } from '../../redux/actions';
export function RenderStatus(props) {
    const [currentStatus, setCurrentStatus] = useState(props.status);
    let style = "";
    if (currentStatus === "Paid") {
        style = "success";
    } else if (currentStatus === "Pending") {
        style = "warning";
    } else if (currentStatus === "Approved") {
        style = "info";
    }
    let dispatch = useDispatch();
    function updateCurrentRecord(data) {
        if ((props.type === "paymentStatus") || (props.type === "invoiceStatus")) {
            expenseUpdate(data);
        }
        else if (props.type === "incomeStatus") {
            incomeUpdate(data);
        }
        else if (props.type === "invoice") {
            invoiceUpdate(data);
        }
    }
    function expenseUpdate(data) {
        var value = 0;
        if (props.type === "paymentStatus") {
            if (data === "Paid") {
                value = 111
            }
            else if (data === "Pending") {
                value = 112
            }
            else {
                value = 113
            }
        }
        else if (props.type === "invoiceStatus") {
            if (data === "Paid") {
                value = 114
            }
            else if (data === "Pending") {
                value = 115
            }
            else {
                value = 116
            }
        }
        setCurrentStatus(data)
        var finalData = {
            expense: {
                "expenseId": props.dataItem.expenseId,
                "itemDescription": props.dataItem.itemDescription,
                "expenseTypeId": props.dataItem.expenseTypeId,
                "paidBy": props.dataItem.paidBy,
                "paidTo": props.dataItem.paidTo,
                "amount": props.dataItem.amount,
                "paymentTypeId": parseInt(props.dataItem.paymentTypeId),
                "paymentStatusId": props.type === "paymentStatus" ? value : parseInt(props.dataItem.paymentStatusId),
                "invoiceStatusId": props.type === "invoiceStatus" ? value : parseInt(props.dataItem.invoiceStatusId),
                "isRecuring": props.dataItem.isRecuring
            },
            files: []
        }
        dispatch(addExpense(finalData, null));

    }
    function incomeUpdate(data) {
        var value = 0;
        if (data === "Paid") {
            value = 124
        }
        else if (data === "Pending") {
            value = 125
        }
        setCurrentStatus(data)
        var finalData = {
            "incomeId": props.data.incomeId,
            "description": props.data.description,
            "clientId": props.data.clientId,
            "projectId": props.data.projectId,
            "amount": props.data.amount,
            "incomeTypeId": props.data.incomeTypeId,
            "statusId": value,
            "isRecurring": props.data.isRecurring,
            "recursionTypeId": data.recursionTypeId,
            "dueDate": props.data.dueDate,
            files: []
        }
        dispatch(addNewIncome(finalData, null));
    }
    function invoiceUpdate(data) {
        var value = 0;
        if (data === "Paid") {
            value = 124
        }
        else if (data === "Pending") {
            value = 125
        }
        setCurrentStatus(data)
    }
    return (
        <Dropdown className="h-100 w-100" as={ButtonGroup}>
            <Button className="w-100" variant={style}>
                {currentStatus}
            </Button>
            <Dropdown.Toggle split variant={style} id="dropdown-split-basic" />
            <Dropdown.Menu>
                <Dropdown.Item onClick={() => {
                    updateCurrentRecord("Paid")
                }}>
                    {"Paid"}
                </Dropdown.Item>
                {
                    props.type !== "incomeStatus"
                    &&
                    <Dropdown.Item onClick={() => {
                        updateCurrentRecord("Approved")
                    }}>
                        {'Approved'}
                    </Dropdown.Item>
                }
                <Dropdown.Item onClick={() => {
                    updateCurrentRecord("Pending")
                }}>
                    {"Pending"}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}